import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e549b5dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "multi_num" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "multi_upload_text" }, "建议尺寸1920*1080", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "multi_upload_text" }, "（png，jpg，gif，bmp)", -1))
const _hoisted_4 = { class: "multi_center" }
const _hoisted_5 = { class: "multi_center_tags" }
const _hoisted_6 = { class: "multi_icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_c_upload = _resolveComponent("c-upload")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_draggable, {
      class: "dragArea list-group w-full",
      list: _ctx.multiList,
      onChange: _ctx.getMulti,
      onDrop: _ctx.dragDrop
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.multiList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "multi",
            key: index
          }, [
            _createElementVNode("div", _hoisted_1, [
              _withDirectives(_createElementVNode("div", null, _toDisplayString(index >= 9 ? index + 1 : `0${index + 1}`), 513), [
                [_vShow, _ctx.serial]
              ])
            ]),
            _createVNode(_component_c_upload, {
              "file-list": _ctx.fileList,
              "handle-change": (info) => _ctx.handleChange(info, index),
              loading: item.loading,
              "image-name": item.img,
              "click-stop": (info) => _ctx.imageDel(info, index),
              class: "ant_upload"
            }, {
              uploadImg: _withCtx(() => [
                _hoisted_2,
                _hoisted_3
              ]),
              _: 2
            }, 1032, ["file-list", "handle-change", "loading", "image-name", "click-stop"]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_a_button, {
                  onClick: ($event: any) => (_ctx.getSelectLive(0, index)),
                  class: _normalizeClass(item.selectLive == 0 ? 'tags_btn' : '')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("选择直播间")
                  ]),
                  _: 2
                }, 1032, ["onClick", "class"]),
                _createVNode(_component_a_button, {
                  onClick: ($event: any) => (_ctx.getSelectLive(1, index)),
                  class: _normalizeClass(item.selectLive == 1 ? 'tags_btn' : '')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("新建直播间")
                  ]),
                  _: 2
                }, 1032, ["onClick", "class"])
              ]),
              _withDirectives(_createVNode(_component_a_select, {
                class: "multi_select",
                size: "large",
                "show-search": "",
                placeholder: "选择已有直播间",
                value: item.select,
                "onUpdate:value": ($event: any) => ((item.select) = $event),
                onFocus: ($event: any) => (_ctx.getFocus(index)),
                onBlur: ($event: any) => (_ctx.getBlur(index))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (res, resIndex) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: res.id,
                      onClick: ($event: any) => (_ctx.getSelect(index, resIndex)),
                      value: res.title
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(res.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick", "value"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["value", "onUpdate:value", "onFocus", "onBlur"]), [
                [_vShow, item.selectLive == 0]
              ]),
              _withDirectives(_createVNode(_component_a_input, {
                class: "multi_input",
                size: "large",
                placeholder: "输入直播间名称",
                onChange: ($event: any) => (_ctx.getInput(index)),
                value: item.input,
                "onUpdate:value": ($event: any) => ((item.input) = $event)
              }, null, 8, ["onChange", "value", "onUpdate:value"]), [
                [_vShow, item.selectLive == 1]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_svg_icon, {
                onClick: _ctx.toAdd,
                class: "add",
                "icon-class": "add"
              }, null, 8, ["onClick"]),
              (index !== 0)
                ? (_openBlock(), _createBlock(_component_svg_icon, {
                    key: 0,
                    onClick: ($event: any) => (_ctx.toDelete(index)),
                    class: "del",
                    "icon-class": "del"
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["list", "onChange", "onDrop"])
  ]))
}